export const State5 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <path
      d="M6 1C3.2379 1 1 3.2379 1 6C1 8.7621 3.2379 11 6 11C8.7621 11 11 8.7621 11 6C11 3.2379 8.7621 1 6 1ZM3.33871 6.80645C3.20565 6.80645 3.09677 6.69758 3.09677 6.56452V5.43548C3.09677 5.30242 3.20565 5.19355 3.33871 5.19355H8.66129C8.79435 5.19355 8.90323 5.30242 8.90323 5.43548V6.56452C8.90323 6.69758 8.79435 6.80645 8.66129 6.80645H3.33871Z"
      fill="#CE2C31"
    />
  </svg>
);
